<template>
  <v-card max-width="850" flat>
    <div>
      <v-list two-line>
        <v-list-item>
          <v-list-item-icon>
            <v-icon small>mdi-car-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t("report.thgCheckoutVehicleCard.title") }}</v-list-item-title>
            <v-list-item-subtitle
              >{{ $t("report.thgCheckoutVehicleCard.numberplate")
              }}<v-btn v-if="!hideEdit" text x-small color="info" @click="goToContactData">{{
                $t("edit")
              }}</v-btn></v-list-item-subtitle
            >
            <v-list-item-subtitle>
              {{ showValueOrDefault(numberplate, "components.thg.ThgCreateOverviewCard.numberplate") }}
            </v-list-item-subtitle>

            <v-list-item-subtitle class="mt-4">
              {{ $t("components.thg.ThgCreateOverviewCard.registration") }}
              <v-btn v-if="!hideEdit" text x-small color="info" @click="goToRegistration">{{ $t("edit") }}</v-btn>
            </v-list-item-subtitle>
            <v-list-item-subtitle>
              {{ $t("components.thg.ThgCreateOverviewCard.registrationHint") }}
            </v-list-item-subtitle>
            <v-list-item-subtitle v-if="isRegistrationFront">
              <image-dialog
                v-if="isRegistrationFront"
                :src="getRegistrationImageFront"
                cardClass="mx-0 mb-2"
                title="Vorderseite"
              />
            </v-list-item-subtitle>
            <v-list-item-subtitle v-else>
              {{ $t("components.thg.ThgCreateOverviewCard.registrationHint2") }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </div>
  </v-card>
</template>

<script lang="ts">
import ImageDialog from "@/components/utility/ImageDialog.vue";
import { IImageUploaded } from "@/models/Image/IImageUploaded";
import { ReportScreenEnum } from "@/store/enum/partner/report-screen.enum";
import { ReportModule } from "@/store/modules/report.store";
import { ThgCreateModule } from "@/store/modules/thg.create.store";
import { Component, Prop } from "vue-property-decorator";
import ThgContactScreensMixin from "./mixins/ThgContactScreensMixin.vue";
import { mixins } from "vue-class-component";
import ThgRegistrationScreensMixin from "./mixins/ThgRegistrationScreensMixin.vue";

@Component({
  components: {
    ImageDialog
  }
})
export default class ThgCheckoutVehicleCard extends mixins(ThgContactScreensMixin, ThgRegistrationScreensMixin) {
  @Prop({ default: false })
  hideEdit?: boolean;

  get numberplate(): string {
    return ThgCreateModule.numberplate;
  }

  showValueOrDefault(value: string, title: string) {
    if (!value.replace(" ", "")) {
      return this.$t("components.thg.ThgCreateOverviewCard.defaultValue", { title: this.$t(title) });
    }

    return value;
  }

  goToContactData() {
    const screenName = this.contactScreens.find((screen) => ReportModule.screenOder.includes(screen));

    if (screenName) {
      this.goToScreen(screenName);
    } else {
      this.$toast.error(this.$t("components.thg.ThgCreateOverviewCard.errors.thgcontact"));
      this.$log.error(this.$t("components.thg.ThgCreateOverviewCard.errors.thgcontact"));
    }
  }

  goToRegistration() {
    const screenName = this.registrationScreens.find((screen) => ReportModule.screenOder.includes(screen));

    if (screenName) {
      this.goToScreen(screenName);
    } else {
      this.$toast.error(this.$t("components.thg.ThgCreateOverviewCard.errors.registration"));
      this.$log.error(this.$t("components.thg.ThgCreateOverviewCard.errors.registration"));
    }
  }

  goToScreen(screenName: ReportScreenEnum) {
    ReportModule.setStep(screenName);
    this.$router.push({ name: screenName });
  }

  get isRegistrationFront(): number {
    return ThgCreateModule.registrationImageFront.length;
  }

  fileToUrl(imageUploaded: IImageUploaded) {
    if (!imageUploaded || !imageUploaded.file) {
      return "";
    }

    let url = "";
    try {
      url = URL.createObjectURL(imageUploaded.file);
    } catch (error) {
      this.$log.error(error);
    }

    return url;
  }

  get getRegistrationImageFront(): string {
    if (ThgCreateModule.registrationImageFront.length === 0) {
      return "";
    }
    return this.fileToUrl(ThgCreateModule.registrationImageFront[0]);
  }
}
</script>
